export const SERVER = process.env.REACT_APP_SERVER
export const capitalizeFirstLetter = (val) => {
  if (!val) return "";
  const str = val.trimStart();
  return str.charAt(0).toUpperCase() + str.slice(1);
};
